<section class="d-none d-md-block" aria-labelledby="getApp">
    <div class="col-12 p-4 d-flex flex-wrap align-items-center get-app">
        <div class="col-sm-12 col-md-auto mb-4 icon-logo d-flex align-items-center justify-content-end">
            <img [src]="dwnapp?.imageUrl || 'assets/images/logo_orange.svg'" alt="..." class="img-fluid">
        </div>
    
        <div class="col-sm-12 col-md-10 p-0 pl-md-5">
            <div class="w-100 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center">
                <div>
                    <h2 id="getApp" class="mb-4 mb-md-0">{{dwnapp?.title}}</h2>
                    <p class="mb-md-0 mt-3">{{dwnapp?.description}}</p>
                </div>
                <div style="width: 195px; text-align: center;">
                    <img src="../../../../assets/images/qrcode.jpeg" alt="download shaktipeeth app from google play"
                    class="img-fluid download" style="width: 120px;margin-bottom: 10px;">
                    <a href="{{dwnapp?.appUrl}}" target="_blank">
                        <img src="assets/images/googleplay.png" alt="download shaktipeeth app from google play"
                            class="img-fluid download">
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="d-block d-md-none" aria-labelledby="getApp">
    <div class="col-12 p-4 d-flex flex-wrap align-items-center get-app hide-md">
        <div class="col-sm-12 col-md-10 p-0 pl-md-5">
            <div class="w-100 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center">
                <div>
                    <h2 id="getApp" class="mb-md-0 font-20">{{dwnapp?.title}}</h2>
                    <p class="mb-md-0 mt-2 mt-md-3">{{dwnapp?.description}}</p>
                </div>
                <div class="w-100 d-flex align-items-center justify-content-between">
                    <img src="../../../../assets/images/qrcode.jpeg" alt="download shaktipeeth app from google play"
                    class="img-fluid download" style="width: 120px;margin-bottom: 10px;">
                    <a href="{{dwnapp?.appUrl}}" target="_blank">
                        <img src="assets/images/googleplay.png" alt="download shaktipeeth app from google play"
                            class="img-fluid download">
                    </a>
                </div>
            </div>
        </div>
    </div>

</section>
